import React from 'react';
import PageHeader from '../components/HeroSection';
import ContactSection from '../components/ContactSection';
import BookSection from '../components/BookSection';
import ArtistSection from '../components/ArtistSection';
import StyleSection from '../components/StyleSection';
import { Helmet } from 'react-helmet';
const ArtistsPage = () => {

  return (
    <div className="min-h-screen bg-white">
      {/* Page Header with Hero */}
      <PageHeader pageTitle="ARTISTS" />

      {/* <div className="w-full max-w-[1792px] mx-4 lg:mx-16 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl lg:text-6xl font-montserrat font-bold text-black mb-6">
            OUR ARTISTS
          </h1>
          <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            Meet the talented stylists and colorists who make Hair To Dye For your premier destination for hair transformation.
          </p>
        </div>
      </div> */}

      {/* Artist Profile Section - Gwen Crouse */}
      <ArtistSection />

      {/* Style Section - All Artists */}
      <StyleSection />

      {/* Book Section */}
      <BookSection />

      {/* Contact Section */}
      <ContactSection />
    </div>
  );
};

export default ArtistsPage;